import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {compose} from 'ramda'
import {withSuspense} from '@modifi/plugin-onboarding'

import {
  aInitializePage,
  aReset,
  aSavePage,
  selectInitialFormDataForCreation,
  selectInitializePagePending,
  selectSaveErrorMessage,
  selectSaveHasError,
  selectSavePending,
} from '../store/form'
import {selectAvailableDataSourceOptions, aSelectPersonAsDataSource} from '../store/data-source'
import CreateBeneficialOwner, {CreateBeneficialOwnerProps} from './CreateBeneficialOwner'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  CreateBeneficialOwnerProps,
  'isLoading' | 'updatePending' | 'formData' | 'hasError' | 'errorMessage' | 'dataSources'
> => ({
  isLoading: selectInitializePagePending(state),
  updatePending: selectSavePending(state),
  formData: selectInitialFormDataForCreation(state),
  hasError: selectSaveHasError(state),
  errorMessage: selectSaveErrorMessage(state),
  dataSources: selectAvailableDataSourceOptions(state),
})

const mapDispatchToProps = {
  initialize: aInitializePage,
  onSubmit: aSavePage,
  onDiscard: aReset,
  onSelectDataSource: aSelectPersonAsDataSource,
  redirect: aPush,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  withSuspense(false)(CreateBeneficialOwner)
)
